import { loadCrmLibs } from './loadCrmLibsPromise.js'

export function postDataToCRM () {
  return new Promise((resolve, reject) => {
    loadCrmLibs()
      .then(_ => {
        createObject({
          onComplete: resolve,
          onError: reject
        })
      })
      .catch(console.error)
  })
}

function createObject ({onComplete, onError}) {
  const config = getConfig()
  // window.landing.onResponse = showCRMResponse
  window.landing.onComplete = onComplete // parent promise resolve
  window.landing.onError = onError
  window.landing.createObjectFromLanding(config)
}

function getConfig () {
  const landingId = {
    delete_account: '56a9224c-ce99-4964-a1bc-0ece7e034127'
  }

  /* eslint-disable */
  const config = {
    fields: {
      'Name':       '#crm-hidden-name',         // ФИО контакта, который регистрирует обращение
      'Account':    '#crm-hidden-account',      // Имя компании
      'Phone':      '#crm-hidden-phone',        // Мобильный телефон контакта
      'Email':      '#crm-hidden-email',        // Email контакта
      'Subject':    '#crm-hidden-subject',      // Тема обращения
      'Symptoms':   '#crm-hidden-symptoms'      // Описание обращения
    },
    landingId: landingId.delete_account,
    serviceUrl: 'https://crm.multiplex.ua/0/ServiceModel/GeneratedObjectWebFormService.svc/SaveWebFormObjectData',
    redirectUrl: '/'
  }
  /* eslint-enable */

  return config
}

// Get Msg: method 1
// function showCRMResponse (_) {
//   const s = _.SaveWebFormObjectDataResult
//   const str = s.substring(s.indexOf('resultMessage:') + 'resultMessage:'.length + 1, s.indexOf('resultCode:') - 2)
//   console.log(str)
// }

// Get Msg: method 2
// XSS security risk
// function showCRMResponse (_) {
//   let  obj;
//   eval('resulting_object = new Object('+_.SaveWebFormObjectDataResult+')');
//   console.log(obj)
//   if ('resultMessage' in obj) {
//     console.log(obj.resultMessage)
//   }
// }



// WEBPACK FOOTER //
// ./src/components/profile-page/impl/delete-account/imlp/modal/logic/crm/index.js